import {
  grayColor,
  primaryColor,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  roseColor,
} from 'assets/jss/material-dashboard-react';

const buttonStyle = {
  button: {
    minHeight: 'auto',
    height: 40,
    minWidth: 114,
    width: 'auto',
    backgroundColor: grayColor,
    color: '#FFFFFF',
    borderRadius: '8px',
    position: 'relative',
    marginRight: 10,
    fontSize: '14px',
    fontWeight: 500,
    textTransform: 'none',
    letterSpacing: '0',
    lineHeight: '1.42857143',
    textAlign: 'center',
    whiteSpace: 'nowrap',
    verticalAlign: 'middle',
    touchAction: 'manipulation',
    cursor: 'pointer',
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease, transform 0.15s ease',
    '& .fab,& .fas,& .far,& .fal': {
      position: 'relative',
      display: 'inline-block',
      top: '0',
      marginTop: '-1em',
      marginBottom: '-1em',
      fontSize: '1.1rem',
      marginRight: '4px',
      verticalAlign: 'middle',
    },
    '& svg': {
      position: 'relative',
      display: 'inline-block',
      top: '0',
      width: '18px',
      height: '18px',
      marginRight: '4px',
      verticalAlign: 'middle',
    },
    '&$justIcon': {
      '& .fab,& .fas,& .far,& .fal': {
        marginTop: '0px',
        position: 'absolute',
        width: '100%',
        transform: 'none',
        left: '0px',
        top: '0px',
        height: '100%',
        lineHeight: '41px',
        fontSize: '20px',
      },
    },
  },
  white: {
    '&,&:focus,&:hover': {
      backgroundColor: '#FFFFFF',
      color: grayColor,
    },
  },
  rose: {
    backgroundColor: roseColor,
    '&:hover,&:focus': {
      backgroundColor: roseColor,
      boxShadow: `0px 0px 10px 0px ${grayColor}`,
    },
  },
  primary: {
    backgroundColor: primaryColor,
    boxShadow: '0 6px 16px rgba(0, 168, 188, 0.25)',
    '&:hover,&:focus': {
      backgroundColor: '#008A9A',
      boxShadow: '0 8px 20px rgba(0, 168, 188, 0.32)',
    },
  },
  info: {
    backgroundColor: infoColor,
    '&:hover,&:focus': {
      backgroundColor: infoColor,
      boxShadow: `0px 0px 10px 0px ${grayColor}`,
    },
  },
  success: {
    backgroundColor: successColor,
    '&:hover,&:focus': {
      backgroundColor: successColor,
      boxShadow: `0px 0px 10px 0px ${grayColor}`,
    },
  },
  warning: {
    backgroundColor: warningColor,

    '&:hover,&:focus': {
      backgroundColor: warningColor,
      boxShadow: `0px 0px 10px 0px ${grayColor}`,
    },
  },
  danger: {
    backgroundColor: dangerColor,
    '&:hover,&:focus': {
      backgroundColor: dangerColor,
      boxShadow: `0px 0px 10px 0px ${grayColor}`,
    },
  },
  gray: {
    backgroundColor: grayColor,
    '&:hover,&:focus': {
      backgroundColor: grayColor,
      boxShadow: `0px 0px 10px 0px ${grayColor}`,
    },
  },
  simple: {
    '&,&:focus,&:hover': {
      color: '#FFFFFF',
    },
    '&$rose': {
      '&,&:focus,&:hover,&:visited': {
        color: roseColor,
      },
    },
    '&$primary': {
      '&,&:focus,&:hover,&:visited': {
        color: primaryColor,
      },
    },
    '&$info': {
      '&,&:focus,&:hover,&:visited': {
        color: infoColor,
      },
    },
    '&$success': {
      '&,&:focus,&:hover,&:visited': {
        color: successColor,
      },
    },
    '&$warning': {
      '&,&:focus,&:hover,&:visited': {
        color: warningColor,
      },
    },
    '&$danger': {
      '&,&:focus,&:hover,&:visited': {
        color: dangerColor,
      },
    },
  },
  transparent: {
    '&,&:focus,&:hover': {
      color: 'inherit',
      background: 'transparent',
      boxShadow: 'none !important',
    },
  },
  disabled: {
    opacity: '0.65',
    pointerEvents: 'none',
    '&,&:focus,&:hover': {
      boxShadow: 'none',
    },
  },
  lg: {
    padding: '1.125rem 2.25rem',
    fontSize: '0.875rem',
    lineHeight: '1.333333',
    borderRadius: '0.2rem',
  },
  sm: {
    padding: '0.40625rem 1.25rem',
    fontSize: '0.6875rem',
    lineHeight: '1.5',
    borderRadius: '0.2rem',
  },
  round: {
    borderRadius: '30px',
  },
  block: {
    width: '100% !important',
  },
  link: {
    '&,&:hover,&:focus': {
      backgroundColor: 'transparent',
      color: primaryColor,
      padding: 5,
      margin: 5,
      boxShadow: 'none !important',
    },
    '&$rose': {
      '&,&:focus,&:hover,&:visited': {
        color: roseColor,
      },
    },
    '&$primary': {
      '&,&:focus,&:hover,&:visited': {
        color: primaryColor,
      },
    },
    '&$info': {
      '&,&:focus,&:hover,&:visited': {
        color: infoColor,
      },
    },
    '&$success': {
      '&,&:focus,&:hover,&:visited': {
        color: successColor,
      },
    },
    '&$warning': {
      '&,&:focus,&:hover,&:visited': {
        color: warningColor,
      },
    },
    '&$danger': {
      '&,&:focus,&:hover,&:visited': {
        color: dangerColor,
      },
    },
    '&$gray': {
      '&,&:focus,&:hover,&:visited': {
        color: grayColor,
      },
    },
  },
  outline: {
    '&,&:hover,&:focus': {
      backgroundColor: 'transparent',
      border: 'solid 2px',
    },
    '&$primary': {
      color: primaryColor,
      borderColor: primaryColor,
    },
    '&$danger': {
      color: dangerColor,
      borderColor: dangerColor,
    },
  },
  justIcon: {
    paddingLeft: '12px',
    paddingRight: '12px',
    fontSize: '20px',
    height: '41px',
    minWidth: '41px',
    width: '41px',
    '& .fab,& .fas,& .far,& .fal,& svg': {
      marginRight: '0px',
    },
    '&$lg': {
      height: '57px',
      minWidth: '57px',
      width: '57px',
      lineHeight: '56px',
      '& .fab,& .fas,& .far,& .fal': {
        fontSize: '32px',
        lineHeight: '56px',
      },
      '& svg': {
        width: '32px',
        height: '32px',
      },
    },
    '&$sm': {
      height: '30px',
      minWidth: '30px',
      width: '30px',
      '& .fab,& .fas,& .far,& .fal': {
        fontSize: '17px',
        lineHeight: '29px',
      },
      '& svg': {
        width: '17px',
        height: '17px',
      },
    },
    '&,&:focus,&:hover': {
      boxShadow: 'none',
    },
  },
};

export default buttonStyle;
